import { FC, useRef } from 'react'
import styles from './NoWearableNeeded.module.scss'
import { NoWearableNeededProps } from './NoWearableNeeded.types'
import { Button } from 'components/Phantom/Button'
import { Type } from 'components/Type'
import { useAnimateInOnScroll } from 'components/_hooks/useAnimateInOnScroll'

export const NoWearableNeeded: FC<NoWearableNeededProps> = (props) => {
	const { benefits = defaultBenefits } = props
	return (
		<section className={styles.container}>
			<div className={styles.content}>
				<header>
					<Type.Headline1
						animateOnScroll
						as={'h2'}
					>
						More and better sleep. No wearable or prescription needed.
					</Type.Headline1>
					<Type.Body1 animateOnScroll>
						Sleep is foundational to your health. We go beyond wearables, to deliver sleep improvement without the need to charge, wear, or remember to take anything. We lean on the science to develop
						products that personalize your sleep environment for optimal recovery.
					</Type.Body1>
					<Button.TextLink
						id={'no-wearable-needed-read-more'}
						href={'/blog/science/'}
					>
						Read more on our blog
					</Button.TextLink>
				</header>
				<ul className={styles.benefits}>
					{benefits.map((benefit, index) => (
						<Benefit
							key={index}
							index={index}
							text={benefit}
						/>
					))}
				</ul>
			</div>
		</section>
	)
}

const Benefit: FC<{ index: number; text: string }> = (props) => {
	const { index } = props

	const ref = useRef<HTMLLIElement>(null)

	useAnimateInOnScroll(ref)
	return (
		<li
			key={index}
			ref={ref}
		>
			<Check />
			<Type.Headline5 as={'p'}>{props.text}</Type.Headline5>
		</li>
	)
}

const defaultBenefits = [
	'Automatic sleep improvement',
	'Tracks sleep and health without a wearable',
	'Non-invasive sleep aid',
	'No effort or action needed',
	'Improved sleeping comfort',
	'Personalized solutions',
	"Doesn't require a prescription",
]

const Check = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 32 32"
		fill="none"
	>
		<g clipPath="url(#clip0_14131_38548)">
			<circle
				cx="16"
				cy="16"
				r="16"
				fill="#1862FF"
			/>
			<path
				d="M13.5008 18.4998L10.3107 15.3097C10.2122 15.2112 10.0953 15.1331 9.9666 15.0797C9.83791 15.0264 9.69999 14.999 9.56069 14.999C9.4214 14.999 9.28347 15.0264 9.15478 15.0797C9.02609 15.1331 8.90916 15.2112 8.81067 15.3097C8.71218 15.4082 8.63405 15.5251 8.58074 15.6538C8.52744 15.7825 8.5 15.9204 8.5 16.0597C8.5 16.199 8.52744 16.3369 8.58074 16.4656C8.63405 16.5943 8.71218 16.7112 8.81067 16.8097L14.0008 21.9999L22.2541 11.8046C22.4141 11.6076 22.5011 11.3615 22.5011 11.1075V11.0335C22.501 10.8236 22.437 10.6187 22.3176 10.446C22.1983 10.2733 22.0291 10.1411 21.8328 10.0668C21.6364 9.99258 21.4221 9.97986 21.2183 10.0304C21.0146 10.0809 20.831 10.1922 20.692 10.3495L13.5008 18.4998Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_14131_38548">
				<rect
					width="32"
					height="32"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
)
